// src/hooks/useImagesModal.js
import { useCallback, useMemo, useState } from 'react'

export const useProductImagesPreviewModal = products => {
  const [showModal, setShowModal] = useState(false)
  const [selectedProductId, setSelectedProductId] = useState(null)
  const [selectedImageId, setSelectedImageId] = useState(null)

  const selectedProduct = useMemo(
    () => products.find(product => product.id === selectedProductId) || {},
    [products, selectedProductId]
  )

  const formattedProductImages = useMemo(() => {
    const images = selectedProduct.images || []
    return images.map((image, index) => ({
      image: image.image,
      id: image.id,
      title: `Image ${index + 1}`
    }))
  }, [selectedProduct])

  const openModal = useCallback((productId, imageId) => {
    setShowModal(true)
    setSelectedProductId(productId)
    setSelectedImageId(imageId)
  }, [])

  const closeModal = useCallback(() => {
    setShowModal(false)
  }, [])

  const handleSelectImage = useCallback(imageId => {
    setSelectedImageId(imageId)
  }, [])

  return {
    showModal,
    selectedProduct,
    formattedProductImages,
    selectedImageId,
    openModal,
    closeModal,
    handleSelectImage
  }
}
